var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{class:_vm.pageStyle.width,attrs:{"placeholder":_vm.placeholder ? _vm.placeholder : _vm.$t('ticket.component.type.placeholder'),"options":_vm.options,"props":{ checkStrictly: true }},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }